const indexData = [
  { icon: 'ri-movie-line', title: '51吃瓜专区', desc: '经典51吃瓜视频合集，热门娱乐八卦一网打尽', count: '2,340条' },
  { icon: 'ri-live-line', title: '91吃瓜频道', desc: '91吃瓜最新视频实时更新，紧跟热点事件', count: '1,856条' },
  { icon: 'ri-spy-line', title: '黑料扒皮', desc: '深度挖掘明星网红黑历史，独家爆料汇总', count: '987条' },
  { icon: 'ri-fire-line', title: '实时热搜', desc: '当前最火爆的吃瓜话题，热度实时追踪', count: '532条' },
  { icon: 'ri-emotion-laugh-line', title: '名场面集锦', desc: '娱乐圈经典翻车名场面，笑料不断', count: '1,640条' },
  { icon: 'ri-chat-smile-2-line', title: '瓜友热议', desc: '吃瓜群众热门讨论帖，一起交流吃瓜心得', count: '3,210条' },
  { icon: 'ri-tv-2-line', title: '综艺爆料', desc: '热门综艺节目幕后爆料与未播花絮合集', count: '756条' },
];

export default function IndexSection() {
  const handleClick = (e: React.MouseEvent) => { e.preventDefault(); };

  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-8 h-8 rounded-lg bg-accent-500 flex items-center justify-center">
            <i className="ri-grid-line text-background-50 text-lg"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">吃瓜专题索引</h2>
        </div>
        <p className="text-foreground-500 text-sm mb-8 md:mb-10">按专题分类浏览，快速找到你感兴趣的51吃瓜、91吃瓜及黑料吃瓜内容</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {indexData.map((item, i) => (
            <a
              key={i}
              href="#index"
              onClick={handleClick}
              className="flex items-start gap-4 p-5 rounded-xl bg-background-100 hover:bg-background-200/70 transition-colors cursor-pointer group"
            >
              <div className="w-11 h-11 rounded-xl bg-accent-100 flex items-center justify-center shrink-0 group-hover:bg-accent-200 transition-colors">
                <i className={`${item.icon} text-accent-600 text-xl`}></i>
              </div>
              <div className="min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="font-semibold text-foreground-900 text-sm">{item.title}</h3>
                  <span className="text-[10px] text-accent-600 font-medium bg-accent-50 px-1.5 py-0.5 rounded shrink-0">{item.count}</span>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}